import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { isIOS, isAndroid, isMobile } from 'react-device-detect';
import { AndroidDownloadLink, IOSDownloadButtonSvg, IOSDownloadLink, qrURL } from '../../shared/constants';
import { CustomLightButton } from '../MuiStyledItems/CustomButtons';
import { DownloadAppButtonProps } from './DownloadAppButton.config';

const DownloadAppButton = (props: DownloadAppButtonProps) => {
  if(isMobile){
    if (isIOS) {
        return (
              <a style={{height:"51.5px"}} href={IOSDownloadLink}>
                <Image width={154} height={52} src={IOSDownloadButtonSvg}></Image>
              </a>
          )
    }
    else if(isAndroid){
        return (
            <CustomLightButton fullWidth={props.fullWidth} href={AndroidDownloadLink}>download the app</CustomLightButton>
          )
    }
    else{
        return (
            <Typography variant="customBody">neither ios nor android</Typography>
        )
    }
}
  else{
    return (
        <Box width={100} height={100}>
          <Image width={100} height={100} src={qrURL as string} alt="qr"></Image>
        </Box>
      )
  }
}

export default DownloadAppButton